const IMPORT_PLACEHOLDER_EMAIL_PATTERN = /^import\.\d+@import\.careergrad\.local$/i;

export function displayContactEmail(email?: string | null): string {
  const trimmed = email?.trim() ?? '';
  if (!trimmed || IMPORT_PLACEHOLDER_EMAIL_PATTERN.test(trimmed)) {
    return '';
  }
  return trimmed;
}

export function hasDisplayContactEmail(email?: string | null): boolean {
  return displayContactEmail(email).length > 0;
}
